"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResource = void 0;
const app_1 = require("@koopajs/app");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const useResource = (props) => {
    const { id, path, useCache = false } = props;
    const dispatch = react_redux_1.useDispatch();
    const dispatchEntitiesSave = app_1.Operations.Entities.save(dispatch);
    const activeWorkspaceId = react_redux_1.useSelector(app_1.Selectors.Workspaces.getActiveWorkspaceId);
    const { errorMessage, isProcessing } = react_redux_1.useSelector(app_1.Selectors.Entities.stateByItemId(path, id));
    const resource = react_redux_1.useSelector(app_1.Selectors.Entities.getItemById(path, id));
    react_1.useEffect(() => {
        const core = async () => {
            if (true /*workspaceId*/ && id && id !== '_') {
                await app_1.Operations.Entities.fetchOne(dispatch)(activeWorkspaceId, path, id);
            }
        };
        if (!useCache) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            core();
        }
    }, [activeWorkspaceId, path, id, useCache]);
    const setResource = async (attributes) => {
        return await dispatchEntitiesSave(activeWorkspaceId, path, attributes, id);
    };
    return {
        errorMessage,
        isProcessing,
        resource,
        setResource
    };
};
exports.useResource = useResource;
//# sourceMappingURL=useResource.js.map